import { render } from "./OrderButtonComponent.vue?vue&type=template&id=4715f65d&scoped=true&ts=true"
import script from "./OrderButtonComponent.vue?vue&type=script&lang=ts"
export * from "./OrderButtonComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/TCD-GIFTSHOP-CHANNELING-FRONT/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4715f65d"]])

export default __exports__